import gql from "graphql-tag";

/* Backend LoginPayload returns: token, user { id, email, role }, isArtist, isAdmin, isAffiliate, affiliate, affiliateId */
const LOGIN_USER = gql`
  mutation ($email: String!, $password: String!, $webPushToken: String) {
    login: login(
      email: $email
      password: $password
      webPushToken: $webPushToken
    ) {
      token
      user {
        id
        email
        role
      }
    }
  }
`;

interface loginInterface {
  token: string;
  user: {
    id: string;
    email: string;
    role: string;
  };
}

export interface LOGIN_USERResponse {
  login: loginInterface;
}

export interface LOGIN_USERVariables {
  email: string;
  password: string;
  webPushToken?: string;
}

const LOGIN_MUTATION = LOGIN_USER;
export default LOGIN_MUTATION;

